import Vue from "vue"
import Vuex from 'vuex';

import VuexPersistence from 'vuex-persist'

Vue.use(Vuex);

// //创建对象配置持久化
const vuexLocal = new VuexPersistence({
	//定义本地存储的方式，sessionStorage或localStorage
	storage: window.sessionStorage
})

const store = new Vuex.Store({
	state: {
		//登录信息
		loginInfo: {
			admin_id: '', //uid
			group_id: '', //角色id
			group_name: '', //角色名称
			nick_name: '', //用户名
			phone: '', //手机号
			sid: '',
			supplier_id: '', //供应商id
			token: '', // 系统token
            depart_name: '',
            login_ip: '',
            login_time: '',
            avatar: '',
		},
		openTab: [], //所有打开的路由
		activeIndex: '/home', //激活状态
		//企业信息
		businessInfo: {
			combination_name: '', //版本
			expire_time: '', //过期时间
			image: '', //logo
			title: '', //公司名称
			plat_name: '', //公司简介
            crm_model: '',
		},
		menuInfo: [], //一级菜单
        permitArr: [], 
	},
	getters: {
		loginInfo: state => state.loginInfo.token == '' ? JSON.parse(localStorage.getItem('loginInfo')) : state
			.loginInfo,
		businessInfo: state => state.businessInfo == {} ? JSON.parse(localStorage.getItem('businessInfo')) :
			state
			.businessInfo,
		menuInfo: state => state.menuInfo == {} ? JSON.parse(localStorage.getItem('menuInfo')) :
			state
			.menuInfo,
        permitArr : state => state.menuInfo == {} ? JSON.parse(localStorage.getItem('menuInfo')) : state.menuInfo,
	},
	mutations: {
		//存储登录信息
		setLoginInfo(state, loginInfo) {
			for (var key in loginInfo) {
				if (state.loginInfo.hasOwnProperty(key)) {
					state.loginInfo[key] = loginInfo[key];
				}
			}
			localStorage.setItem('loginInfo', JSON.stringify(state.loginInfo))
		},

		//存储企业信息
		setBusinessInfo(state, businessInfo) {
			for (var key in businessInfo) {
				if (state.businessInfo.hasOwnProperty(key)) {
					state.businessInfo[key] = businessInfo[key];
				}
			}
			localStorage.setItem('businessInfo', JSON.stringify(state.businessInfo))
		},
		
		//存储一级菜单
		setMenuInfo(state, menuInfo){
			var arr = []
			menuInfo.forEach((item)=>{
				arr.push(item.href)
			})
			state.menuInfo = arr;
			localStorage.setItem('menuInfo', JSON.stringify(state.menuInfo))
		},

        setPermitArr(state, permitArr){
			state.permitArr = permitArr;
			localStorage.setItem('permitArr', JSON.stringify(state.permitArr))
		},

		//清除信息
		clearToken() {
			localStorage.removeItem('loginInfo');
			localStorage.removeItem('businessInfo');
			localStorage.removeItem('menuInfo');
			localStorage.removeItem('tabIndex');
		},
		// 添加tabs
		add_tabs(state, data) {
			if (data.route == '/home') {
				this.state.openTab.splice(0, 0, data)
			} else {
				this.state.openTab.push(data);
			}
		},
		// 删除tabs
		delete_tabs(state, route) {
			let index = 0;
			for (let option of state.openTab) {
				if (option.fullPath === route) {
					break;
				}
				index++;
			}
			this.state.openTab.splice(index, 1);
		},
        set_tabs(state, data) {
			this.state.openTab = data;
		},
		// 设置当前激活的tab
		set_active_index(state, index) {
			this.state.activeIndex = index;
		},
	},
	actions: {

		setLoginInfo({
			commit
		}, loginInfo) {
			commit('setLoginInfo', loginInfo);
		},

		setBusinessInfo({
			commit
		}, businessInfo) {
			commit('setBusinessInfo', businessInfo);
		},
		
		setMenuInfo({
			commit
		}, menuInfo) {
			commit('setMenuInfo', menuInfo);
		},

        setPermitArr({
			commit
		}, permitArr) {
			commit('setPermitArr', permitArr);
		}
	},

	// //配置插件支持
	plugins: [vuexLocal.plugin]
});

export default store;